import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=4f849f5f&scoped=true&"
import script from "./Milestone.vue?vue&type=script&lang=js&"
export * from "./Milestone.vue?vue&type=script&lang=js&"
import style0 from "./Milestone.vue?vue&type=style&index=0&id=4f849f5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f849f5f",
  null
  
)

export default component.exports